/* global canManageRisks canManageIssues canManageDecisions canCreateOpportunities canEditOpportunities canDeleteOpportunities */
/* global getGeneralRiskActionSummaryUrl fetchGeneralRisksUrl fetchGeneralIssuesUrl fetchGeneralDecisionsUrl */
/* global fetchGeneralRiskBudgetLinesUrl fetchGeneralRiskTypesUrl fetchGeneralRiskImpactsUrl fetchGeneralImpactCategoriesUrl */
/* global fetchGeneralRiskProbabilitiesUrl fetchGeneralRiskStatusesUrl updateGeneralRiskHotStatusUrl updateGeneralIssueHotStatusUrl */
/* global updateGeneralDecisionHotStatusUrl generalRisksActionSummaryExportUrl deleteGeneralRiskUrl restoreGeneralRiskUrl forceDeleteGeneralRiskUrl fetchTrashedGeneralRisksUrl deleteGeneralIssueUrl deleteGeneralDecisionUrl fetchGeneralRiskDashboardUrl listUsersUrl */
/* global generalRisksExportUrl fetchGeneralRiskUrl reorderGeneralRiskUrl fetchGeneralIssueUrl fetchGeneralDecisionUrl getGeneralRiskPriorityUrl */
/* global storeGeneralRiskUrl updateGeneralRiskUrl storeGeneralIssueUrl  updateGeneralIssueUrl  storeGeneralDecisionUrl updateGeneralDecisionUrl */
/* global reorderGeneralIssueUrl reorderGeneralDecisionUrl fetchEventDepartmentsOptionsUrl fetchGeneralRiskWeightedValuesUrl updateGeneralRiskWeightedValueUrl */
/* global importGeneralRisksUrl importGeneralIssuesUrl importGeneralDecisionsUrl fetchVenuesOptionsUrl */
/* global canCreateAssumption canUpdateAssumption canDeleteAssumption canDeleteAssumptionItem canVerifyAssumptionItem */
/* global bulkDeleteCentralAssumptionGroupUrl deleteCentralAssumptionAttachmentUrl downloadCentralAssumptionAttachmentUrl */
/* global importCentralAssumptionsUrl storeCentralAssumptionGroupUrl updateCentralAssumptionGroupUrl updateAssumptionCategoriesOrderUrl */
/* global fetchGeneralOpportunitiesUrl storeGeneralOpportunityUrl updateGeneralOpportunityUrl deleteGeneralOpportunityUrl importGeneralOpportunitiesUrl restoreGeneralOpportunityUrl forceDeleteGeneralOpportunityUrl fetchTrashedGeneralOpportunitiesUrl */

import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import Select from 'react-select';

import CentralAssumptionsIndex from '../central_assumptions/CentralAssumptionsIndex';

import { CUSTOM_STYLES, DECISION_TYPE, ISSUE_TYPE, OPPORTUNITY_TYPE, RAID_OPTIONS, RISK_TYPE } from './constants';
import { GeneralRiskProvider } from './context/GeneralRiskContext';
import { RaidProvider, useRaidContext } from './context/RaidContext';
import OverviewDashboard from './dashboard/OverviewDashboard';
import GeneralRiskDashboardAssumptions from './GeneralRiskDashboardAssumptions';
import GeneralRiskDashboardDecisions from './GeneralRiskDashboardDecisions';
import GeneralRiskDashboardIssues from './GeneralRiskDashboardIssues';
import GeneralRiskDashboardOpportunities from './GeneralRiskDashboardOpportunities';
import GeneralRiskDashboardRisks from './GeneralRiskDashboardRisks';
import GeneralRiskFramework from './GeneralRiskFramework';
import GeneralRiskWeightedValue from './GeneralRiskWeightedValue';
import ActionSummary from './register/ActionSummary';
import ActionSummaryFilters from './register/ActionSummaryFilters';
import GeneralDecisionsIndex from './register/general_decision/GeneralDecisionsIndex';
import GeneralIssuesIndex from './register/general_issue/GeneralIssuesIndex';
import GeneralOpportunitiesIndex from './register/general_opportunities/GeneralOpportunitiesIndex';
import GeneralRisksIndex from './register/general_risk/GeneralRisksIndex';

import Button from 'CommonComponents/Button';

import { ConfirmationModalProvider } from 'Context/ConfirmationModalContext';
import { UsersProvider } from 'Context/UsersContext';

const hash = new URL(window.location.href).hash;

export default function RadioApp(props) {
    const [isLoading, setIsLoading] = useState({});
    const [actionSummary, setActionSummary] = useState(null);
    const [actionSummaryStatuses, setActionSummaryStatuses] = useState([]);
    const [actionSummaryPriorities, setActionSummaryPriorities] = useState([]);
    const [actionSummaryFilters, setActionSummaryFilters] = useState({});
    const [actionSummaryOrder, setActionSummaryOrder] = useState({ order_by: '', order: '' });

    const { canManageRisks, canManageIssues, canManageDecisions, createByType, importByType } = useRaidContext();

    const addNewOptions = RAID_OPTIONS.filter(
        (option) =>
            ({
                [RISK_TYPE]: !!canManageRisks,
                [ISSUE_TYPE]: !!canManageIssues,
                [DECISION_TYPE]: !!canManageDecisions,
                [OPPORTUNITY_TYPE]: !!canCreateOpportunities,
            })[option.value],
    );

    useEffect(() => {
        fetchActionSummary();
    }, []);

    const fetchActionSummary = (action, options) => {
        let filters = {};
        let order = '';
        if (action === 'filters') {
            setActionSummaryFilters(options);
            filters = options;
            filters.order_by = actionSummaryOrder;
        } else if (action === 'sort') {
            filters = actionSummaryFilters;
            if (options !== actionSummaryOrder.order_by) {
                setActionSummaryOrder({ order_by: options, order: 'asc' });
                filters.order_by = options;
                filters.order = 'asc';
            } else {
                setActionSummaryOrder({ order_by: options, order: actionSummaryOrder.order === 'asc' ? 'desc' : 'asc' });
                filters.order_by = options;
                filters.order = actionSummaryOrder.order === 'asc' ? 'desc' : 'asc';
            }
        } else {
            setActionSummaryFilters({});
            setActionSummaryOrder({ order_by: '', order: '' });
        }
        loading('action-summary');
        axios
            .get(getGeneralRiskActionSummaryUrl, { params: { ...filters } })
            .then(({ data }) => {
                setActionSummary(data.summary);
                setActionSummaryStatuses(data.statuses);
                setActionSummaryPriorities(data.priorities);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => loading('action-summary', false));
    };

    const loading = (key, value = true) => {
        setIsLoading((pervLoading) => ({ ...pervLoading, [key]: value }));
    };

    const handleCreated = () => {
        fetchActionSummary();
    };

    return (
        <div>
            <div className="tw-flex tw-flex-col tw-gap-6">
                <div
                    className="in-nav horizontal"
                    data-tabs-active-classes="active"
                    data-tabs-inactive-classes="inactive"
                    data-default-tab-id="radio-dashboard-tab"
                    data-tabs-toggle="#risks-issues-decisions-tab-content"
                    role="tablist"
                >
                    <button
                        className="in-nav__item"
                        id="radio-dashboard-tab"
                        data-tabs-target="#radio-dashboard"
                        type="button"
                        role="tab"
                        aria-controls="radio-dashboard"
                        aria-selected={hash === '#dashboard'}
                    >
                        {$t('Overview')}
                    </button>
                    <button
                        className="in-nav__item"
                        id="radio-risks-tab"
                        data-tabs-target="#radio-risks"
                        type="button"
                        role="tab"
                        aria-controls="radio-risks"
                        aria-selected={['#risks', '#risks-register'].includes(hash)}
                    >
                        {$t('Risks')}
                    </button>
                    <button
                        className="in-nav__item"
                        id="radio-assumptions-tab"
                        data-tabs-target="#radio-assumptions"
                        type="button"
                        role="tab"
                        aria-controls="radio-assumptions"
                        aria-selected={['#assumptions', '#assumptions-register'].includes(hash)}
                    >
                        {$t('Assumptions')}
                    </button>
                    <button
                        className="in-nav__item"
                        id="radio-decisions-tab"
                        data-tabs-target="#radio-decisions"
                        type="button"
                        role="tab"
                        aria-controls="radio-decisions"
                        aria-selected={['#decisions', '#decisions-register'].includes(hash)}
                    >
                        {$t('Decisions')}
                    </button>
                    <button
                        className="in-nav__item"
                        id="radio-issues-tab"
                        data-tabs-target="#radio-issues"
                        type="button"
                        role="tab"
                        aria-controls="radio-issues"
                        aria-selected={['#issues', '#issues-register'].includes(hash)}
                    >
                        {$t('Issues')}
                    </button>
                    <button
                        className="in-nav__item"
                        id="radio-opportunities-tab"
                        data-tabs-target="#radio-opportunities"
                        type="button"
                        role="tab"
                        aria-controls="radio-opportunities"
                        aria-selected={['#opportunities', '#opportunities-register'].includes(hash)}
                    >
                        {$t('Opportunities')}
                    </button>
                    {addNewOptions.length > 0 && (
                        <div className="tw-flex tw-justify-end tw-items-center tw-w-full tw-mb-2">
                            {(!!canManageRisks || !!canManageIssues || !!canManageDecisions) && (
                                <div className="dropdown mr-2">
                                    <Select
                                        name="import-from-file"
                                        options={RAID_OPTIONS}
                                        menuPortalTarget={document.body} // Renders the menu in the body
                                        styles={{
                                            ...CUSTOM_STYLES,
                                            menuPortal: (base) => ({ ...base, zIndex: 100 }), // Ensures the menu is above other content
                                        }}
                                        onChange={(option) => importByType(option.value)}
                                        defaultValue={{}}
                                        value={null}
                                        placeholder={$t('Import from file')}
                                        isSearchable={false}
                                    />
                                </div>
                            )}
                            <div className="dropdown mr-2">
                                <Select
                                    name="add-new"
                                    options={addNewOptions}
                                    menuPortalTarget={document.body} // Renders the menu in the body
                                    styles={{
                                        ...CUSTOM_STYLES,
                                        menuPortal: (base) => ({ ...base, zIndex: 100 }), // Ensures the menu is above other content
                                    }}
                                    onChange={(option) => createByType(option.value)}
                                    defaultValue={{}}
                                    value={null}
                                    placeholder={$t('Add New')}
                                    isSearchable={false}
                                />
                            </div>
                        </div>
                    )}
                </div>

                <div id="risks-issues-decisions-tab-content">
                    <div id="radio-dashboard" role="tabpanel" aria-labelledby="radio-dashboard-tab">
                        <div className="tw-flex tw-flex-col tw-gap-6">
                            <div
                                className="in-nav horizontal"
                                data-tabs-active-classes="active"
                                data-tabs-inactive-classes="inactive"
                                data-default-tab-id="radio-dashboard-summary-tab"
                                data-tabs-toggle="#radio-dashboard-tab-content"
                                role="tablist"
                            >
                                <button
                                    className="in-nav__item"
                                    id="radio-dashboard-summary-tab"
                                    data-tabs-target="#radio-dashboard-summary"
                                    type="button"
                                    role="tab"
                                    aria-controls="radio-dashboard-summary"
                                    aria-selected="true"
                                >
                                    {$t('Dashboard')}
                                </button>
                                <button
                                    className="in-nav__item"
                                    id="radio-dashboard-actions-tab"
                                    data-tabs-target="#radio-dashboard-actions"
                                    type="button"
                                    role="tab"
                                    aria-controls="radio-dashboard-actions"
                                    aria-selected="false"
                                >
                                    {$t('Actions')}
                                </button>
                                <button
                                    className="in-nav__item"
                                    id="radio-dashboard-framework-tab"
                                    data-tabs-target="#radio-dashboard-framework"
                                    type="button"
                                    role="tab"
                                    aria-controls="radio-dashboard-framework"
                                    aria-selected="false"
                                >
                                    {$t('Framework')}
                                </button>
                            </div>

                            <div id="radio-dashboard-tab-content">
                                <div id="radio-dashboard-summary" role="tabpanel" aria-labelledby="radio-dashboard-summary-tab">
                                    <OverviewDashboard />
                                </div>
                                <div id="radio-dashboard-actions" role="tabpanel" aria-labelledby="radio-dashboard-actions-tab">
                                    <div className="table__card">
                                        <div className="tw-flex tw-items-start tw-justify-between tw-mb-6">
                                            <div>
                                                <h4 className="table__header">{$t('Action Summary')}</h4>
                                            </div>
                                            <div className="tw-flex tw-gap-x-1.5">
                                                <Button variant="primary" as="a" href={generalRisksActionSummaryExportUrl}>
                                                    {$t('Download')}
                                                </Button>
                                                <ActionSummaryFilters
                                                    datasets={{ actionSummaryStatuses, actionSummaryPriorities }}
                                                    onSubmit={(values) => fetchActionSummary('filters', values)}
                                                    onReset={() => fetchActionSummary()}
                                                />
                                            </div>
                                        </div>
                                        <ActionSummary
                                            isLoading={isLoading['action-summary']}
                                            actionSummary={actionSummary}
                                            handleOrderBy={(order) => fetchActionSummary('sort', order)}
                                            actionSummaryOrder={actionSummaryOrder}
                                        />
                                    </div>
                                </div>
                                <div id="radio-dashboard-framework" role="tabpanel" aria-labelledby="radio-dashboard-framework-tab">
                                    <GeneralRiskFramework />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="radio-risks" role="tabpanel" aria-labelledby="radio-risks-tab">
                        <div className="tw-flex tw-flex-col tw-gap-6">
                            <div
                                className="in-nav horizontal"
                                data-tabs-active-classes="active"
                                data-tabs-inactive-classes="inactive"
                                data-default-tab-id="radio-risks-dashboard-tab"
                                data-tabs-toggle="#radio-risks-tab-content"
                                role="tablist"
                            >
                                <button
                                    className="in-nav__item"
                                    id="radio-risks-dashboard-tab"
                                    data-tabs-target="#radio-risks-dashboard"
                                    type="button"
                                    role="tab"
                                    aria-controls="radio-risks-dashboard"
                                    aria-selected={hash === '#risks'}
                                >
                                    {$t('Dashboard')}
                                </button>
                                <button
                                    className="in-nav__item"
                                    id="radio-risks-register-tab"
                                    data-tabs-target="#radio-risks-register"
                                    type="button"
                                    role="tab"
                                    aria-controls="radio-risks-register"
                                    aria-selected={hash === '#risks-register'}
                                >
                                    {$t('Register')}
                                </button>
                                <button
                                    className="in-nav__item"
                                    id="radio-risks-weighted-value-tab"
                                    data-tabs-target="#radio-risks-weighted-value"
                                    type="button"
                                    role="tab"
                                    aria-controls="radio-risks-weighted-value"
                                    aria-selected="false"
                                >
                                    {$t('Risk Weighted Value')}
                                </button>
                            </div>

                            <div id="radio-risks-tab-content">
                                <div id="radio-risks-dashboard" role="tabpanel" aria-labelledby="radio-risks-dashboard-tab">
                                    <GeneralRiskDashboardRisks />
                                </div>
                                <div id="radio-risks-register" role="tabpanel" aria-labelledby="radio-risks-register-tab">
                                    <GeneralRisksIndex handleCreated={handleCreated} />
                                </div>
                                <div id="radio-risks-weighted-value" role="tabpanel" aria-labelledby="radio-risks-weighted-value-tab">
                                    <GeneralRiskWeightedValue fetchUrl={fetchGeneralRiskWeightedValuesUrl} updateUrl={updateGeneralRiskWeightedValueUrl} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="radio-assumptions" role="tabpanel" aria-labelledby="radio-assumptions-tab">
                        <div className="tw-flex tw-flex-col tw-gap-6">
                            <div
                                className="in-nav horizontal"
                                data-tabs-active-classes="active"
                                data-tabs-inactive-classes="inactive"
                                data-default-tab-id="radio-assumptions-dashboard-tab"
                                data-tabs-toggle="#radio-assumptions-tab-content"
                                role="tablist"
                            >
                                <button
                                    className="in-nav__item"
                                    id="radio-assumptions-dashboard-tab"
                                    data-tabs-target="#radio-assumptions-dashboard"
                                    type="button"
                                    role="tab"
                                    aria-controls="radio-assumptions-dashboard"
                                    aria-selected={hash === '#assumptions'}
                                >
                                    {$t('Dashboard')}
                                </button>
                                <button
                                    className="in-nav__item"
                                    id="radio-assumptions-register-tab"
                                    data-tabs-target="#radio-assumptions-register"
                                    type="button"
                                    role="tab"
                                    aria-controls="radio-assumptions-register"
                                    aria-selected={hash === '#assumptions-register'}
                                >
                                    {$t('Register')}
                                </button>
                            </div>

                            <div id="radio-assumptions-tab-content">
                                <div id="radio-assumptions-dashboard" role="tabpanel" aria-labelledby="radio-assumptions-dashboard-tab">
                                    <GeneralRiskDashboardAssumptions />
                                </div>
                                <div id="radio-assumptions-register" role="tabpanel" aria-labelledby="radio-assumptions-register-tab">
                                    <CentralAssumptionsIndex
                                        canCreate={canCreateAssumption}
                                        canUpdate={canUpdateAssumption}
                                        canDelete={canDeleteAssumption}
                                        canDeleteAssumption={canDeleteAssumptionItem}
                                        canVerifyAssumption={canVerifyAssumptionItem}
                                        bulkDeleteCentralAssumptionGroupUrl={bulkDeleteCentralAssumptionGroupUrl}
                                        deleteCentralAssumptionAttachmentUrl={deleteCentralAssumptionAttachmentUrl}
                                        downloadCentralAssumptionAttachmentUrl={downloadCentralAssumptionAttachmentUrl}
                                        importCentralAssumptionsUrl={importCentralAssumptionsUrl}
                                        storeCentralAssumptionGroupUrl={storeCentralAssumptionGroupUrl}
                                        updateCentralAssumptionGroupUrl={updateCentralAssumptionGroupUrl}
                                        updateAssumptionCategoriesOrderUrl={updateAssumptionCategoriesOrderUrl}
                                        fetchVenuesOptionsUrl={fetchVenuesOptionsUrl}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="radio-decisions" role="tabpanel" aria-labelledby="radio-decisions-tab">
                        <div className="tw-flex tw-flex-col tw-gap-6">
                            <div
                                className="in-nav horizontal"
                                data-tabs-active-classes="active"
                                data-tabs-inactive-classes="inactive"
                                data-default-tab-id="radio-decisions-dashboard-tab"
                                data-tabs-toggle="#radio-decisions-tab-content"
                                role="tablist"
                            >
                                <button
                                    className="in-nav__item"
                                    id="radio-decisions-dashboard-tab"
                                    data-tabs-target="#radio-decisions-dashboard"
                                    type="button"
                                    role="tab"
                                    aria-controls="radio-decisions-dashboard"
                                    aria-selected={hash === '#decisions'}
                                >
                                    {$t('Dashboard')}
                                </button>
                                <button
                                    className="in-nav__item"
                                    id="radio-decisions-register-tab"
                                    data-tabs-target="#radio-decisions-register"
                                    type="button"
                                    role="tab"
                                    aria-controls="radio-decisions-register"
                                    aria-selected={hash === '#decisions-register'}
                                >
                                    {$t('Register')}
                                </button>
                            </div>

                            <div id="radio-decisions-tab-content">
                                <div id="radio-decisions-dashboard" role="tabpanel" aria-labelledby="radio-decisions-dashboard-tab">
                                    <GeneralRiskDashboardDecisions />
                                </div>
                                <div id="radio-decisions-register" role="tabpanel" aria-labelledby="radio-decisions-register-tab">
                                    <GeneralDecisionsIndex handleCreated={handleCreated} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="radio-issues" role="tabpanel" aria-labelledby="radio-issues-tab">
                        <div className="tw-flex tw-flex-col tw-gap-6">
                            <div
                                className="in-nav horizontal"
                                data-tabs-active-classes="active"
                                data-tabs-inactive-classes="inactive"
                                data-default-tab-id="radio-issues-dashboard-tab"
                                data-tabs-toggle="#radio-issues-tab-content"
                                role="tablist"
                            >
                                <button
                                    className="in-nav__item"
                                    id="radio-issues-dashboard-tab"
                                    data-tabs-target="#radio-issues-dashboard"
                                    type="button"
                                    role="tab"
                                    aria-controls="radio-issues-dashboard"
                                    aria-selected={hash === '#issues'}
                                >
                                    {$t('Dashboard')}
                                </button>
                                <button
                                    className="in-nav__item"
                                    id="radio-issues-register-tab"
                                    data-tabs-target="#radio-issues-register"
                                    type="button"
                                    role="tab"
                                    aria-controls="radio-issues-register"
                                    aria-selected={hash === '#issues-register'}
                                >
                                    {$t('Register')}
                                </button>
                            </div>

                            <div id="radio-issues-tab-content">
                                <div id="radio-issues-dashboard" role="tabpanel" aria-labelledby="radio-issues-dashboard-tab">
                                    <GeneralRiskDashboardIssues />
                                </div>
                                <div id="radio-issues-register" role="tabpanel" aria-labelledby="radio-issues-register-tab">
                                    <GeneralIssuesIndex handleCreated={handleCreated} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="radio-opportunities" role="tabpanel" aria-labelledby="radio-opportunities-tab">
                        <div className="tw-flex tw-flex-col tw-gap-6">
                            <div
                                className="in-nav horizontal"
                                data-tabs-active-classes="active"
                                data-tabs-inactive-classes="inactive"
                                data-default-tab-id="radio-opportunities-dashboard-tab"
                                data-tabs-toggle="#radio-opportunities-tab-content"
                                role="tablist"
                            >
                                <button
                                    className="in-nav__item"
                                    id="radio-opportunities-dashboard-tab"
                                    data-tabs-target="#radio-opportunities-dashboard"
                                    type="button"
                                    role="tab"
                                    aria-controls="radio-opportunities-dashboard"
                                    aria-selected={hash === '#opportunities'}
                                >
                                    {$t('Dashboard')}
                                </button>
                                <button
                                    className="in-nav__item"
                                    id="radio-opportunities-register-tab"
                                    data-tabs-target="#radio-opportunities-register"
                                    type="button"
                                    role="tab"
                                    aria-controls="radio-opportunities-register"
                                    aria-selected={hash === '#opportunities-register'}
                                >
                                    {$t('Register')}
                                </button>
                            </div>

                            <div id="radio-opportunities-tab-content">
                                <div id="radio-opportunities-dashboard" role="tabpanel" aria-labelledby="radio-opportunities-dashboard-tab">
                                    <GeneralRiskDashboardOpportunities />
                                </div>
                                <div id="radio-opportunities-register" role="tabpanel" aria-labelledby="radio-opportunities-register-tab">
                                    <GeneralOpportunitiesIndex />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

if (document.getElementById('RadioApp')) {
    var root = document.getElementById('RadioApp');
    ReactDOM.render(
        <App>
            <ConfirmationModalProvider>
                <GeneralRiskProvider fetchDashboardUrl={fetchGeneralRiskDashboardUrl}>
                    <UsersProvider fetchUrl={listUsersUrl}>
                        <RaidProvider
                            canManageRisks={canManageRisks}
                            canManageIssues={canManageIssues}
                            canManageDecisions={canManageDecisions}
                            canCreateOpportunities={canCreateOpportunities}
                            canEditOpportunities={canEditOpportunities}
                            canDeleteOpportunities={canDeleteOpportunities}
                            routes={{
                                // Risks routes
                                fetchGeneralRisksUrl,
                                generalRisksExportUrl,
                                fetchGeneralRiskTypesUrl,
                                fetchGeneralRiskImpactsUrl,
                                fetchGeneralRiskProbabilitiesUrl,
                                fetchGeneralRiskStatusesUrl,
                                getGeneralRiskPriorityUrl,
                                updateGeneralRiskHotStatusUrl,
                                reorderGeneralRiskUrl,
                                fetchGeneralRiskUrl,
                                storeGeneralRiskUrl,
                                updateGeneralRiskUrl,
                                fetchGeneralRiskBudgetLinesUrl,
                                deleteGeneralRiskUrl,
                                restoreGeneralRiskUrl,
                                forceDeleteGeneralRiskUrl,
                                fetchTrashedGeneralRisksUrl,
                                importGeneralRisksUrl,

                                // Issues routes
                                fetchGeneralIssuesUrl,
                                updateGeneralIssueHotStatusUrl,
                                deleteGeneralIssueUrl,
                                fetchGeneralIssueUrl,
                                storeGeneralIssueUrl,
                                updateGeneralIssueUrl,
                                reorderGeneralIssueUrl,
                                importGeneralIssuesUrl,

                                // Decisions routes
                                fetchGeneralDecisionsUrl,
                                updateGeneralDecisionHotStatusUrl,
                                deleteGeneralDecisionUrl,
                                fetchGeneralDecisionUrl,
                                storeGeneralDecisionUrl,
                                updateGeneralDecisionUrl,
                                reorderGeneralDecisionUrl,
                                importGeneralDecisionsUrl,

                                // Opportunities
                                fetchGeneralOpportunitiesUrl,
                                storeGeneralOpportunityUrl,
                                updateGeneralOpportunityUrl,
                                deleteGeneralOpportunityUrl,
                                restoreGeneralOpportunityUrl,
                                forceDeleteGeneralOpportunityUrl,
                                fetchTrashedGeneralOpportunitiesUrl,
                                importGeneralOpportunitiesUrl,

                                // Other routes
                                fetchGeneralImpactCategoriesUrl,
                                fetchEventDepartmentsOptionsUrl,
                                fetchVenuesOptionsUrl,
                            }}
                        >
                            <RadioApp
                                canCreate={canCreateAssumption}
                                canUpdate={canUpdateAssumption}
                                canDelete={canDeleteAssumption}
                                canDeleteAssumption={canDeleteAssumptionItem}
                                canVerifyAssumption={canVerifyAssumptionItem}
                                bulkDeleteCentralAssumptionGroupUrl={bulkDeleteCentralAssumptionGroupUrl}
                                deleteCentralAssumptionAttachmentUrl={deleteCentralAssumptionAttachmentUrl}
                                downloadCentralAssumptionAttachmentUrl={downloadCentralAssumptionAttachmentUrl}
                                importCentralAssumptionsUrl={importCentralAssumptionsUrl}
                                storeCentralAssumptionGroupUrl={storeCentralAssumptionGroupUrl}
                                updateCentralAssumptionGroupUrl={updateCentralAssumptionGroupUrl}
                                updateAssumptionCategoriesOrderUrl={updateAssumptionCategoriesOrderUrl}
                                fetchVenuesOptionsUrl={fetchVenuesOptionsUrl}
                            />
                        </RaidProvider>
                    </UsersProvider>
                </GeneralRiskProvider>
            </ConfirmationModalProvider>
        </App>,
        root,
    );
}
